const MINUTES_PER_DAY = 24 * 60;

const pad = (n) => String(n).padStart(2, "0");

// "19:00 → 07:00 (+1)": início e término do plantão, com quantos dias depois ele termina.
// O plantão continua pertencendo só ao dia em que começa (DataTrabalho) — o "(+1)" é a
// única pista de que ele atravessa a meia-noite, para não criar uma segunda ocorrência no
// dia seguinte. Sem hora de início não há o que descrever (null).
export function describeShiftTime({ hora_inicio: start, horas } = {}) {
  if (!start) return null;
  const [hours, minutes] = start.split(":").map(Number);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes) || !(horas > 0)) return start;

  const end = hours * 60 + minutes + Math.round(horas * 60);
  const daysLater = Math.floor(end / MINUTES_PER_DAY);
  const endOfDay = end % MINUTES_PER_DAY;
  const range = `${start} → ${pad(Math.floor(endOfDay / 60))}:${pad(endOfDay % 60)}`;
  return daysLater > 0 ? `${range} (+${daysLater})` : range;
}
